import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../../environments/environment';
import { WebappService } from '../../../../shared/services/webapp.service';
import { DL_COMMERCIAL_PLACE_URL } from '../../../../shared/utils/consts';

@Component({
  selector: 'mobo-restaurant-detail',
  templateUrl: './restaurant-detail.component.html',
  styles: [],
})
export class RestaurantDetailComponent {
  public restaurant!: any;
  public restaurantSlug!: string;
  public defaultImg = environment.defaultImg;
  constructor(
    private route: ActivatedRoute,
    public webappService: WebappService,
    public router: Router,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    const snapshot = this.route.snapshot.params;
    const restaurantSlug = (this.restaurantSlug = snapshot['slug']);
    if (this.isUuid(restaurantSlug)) {
      this.getRestaurantById(restaurantSlug);
    } else {
      this.getRestaurantBySlug(restaurantSlug);
    }
  }

  async getRestaurantById(restaurantId: string) {
    this.restaurant = await this.webappService.getRestaurant(restaurantId);
    if (this.webappService.isBrowser) {
      const cityId = this.restaurant.Addresses[0].CityId;
      this.getCityIfNeeded(cityId);
    }
  }

  async getRestaurantBySlug(restaurantId: string) {
    this.restaurant = await this.webappService.getRestaurantBySlug(
      restaurantId
    );
    if (this.webappService.isBrowser) {
      const cityId = this.restaurant.Addresses[0].CityId;
      this.getCityIfNeeded(cityId);
    }
  }

  public redirectToRestaurant(restaurantSlug: string, restaurantId: string) {
    this.getRestaurantById(restaurantId);
    this.router.navigate(['/restaurante', restaurantSlug]);
  }

  getCityIfNeeded(cityId: string) {
    let currentCity = this.webappService.selectedCity.value;
    if (currentCity != cityId) {
      this.webappService.selectedCity.next(cityId);
    }
  }

  public isUuid(id: string) {
    const regex =
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/g;
    return regex.test(id);
  }

  public copyUrl() {
    const deepLinkUrl = `${DL_COMMERCIAL_PLACE_URL}${this.restaurant.Id}`;

    navigator.clipboard
      .writeText(deepLinkUrl)
      .then(() => {
        this.toastr.success(
          'Link copiado para a área de transferência!',
          'Sucesso'
        );
      })
      .catch((err) => {
        this.toastr.error('Erro ao copiar o link', 'Erro');
      });
  }
}
